<template>

  <div class="middle-box text-center loginscreen">

    <spinner size="large" message="Aguarde..." v-if="showSpinner"></spinner>

    <div class="image-logo">
      <img src="/static/img/logo-ssparisi.png" alt="Logo">
    </div>

    <p>Complete seu cadastro para ter acesso ao sistema.</p>

    <div class="ibox-content animated fadeInDown">
      <div class="row">

        <div class="col-sm-6 b-r">
          <h3 class="text-center"> Dados Cadastrais </h3>

          <div class="form-group required">
            <label for="nome" class="control-label" :class="{ invalid: errors.has('nome')}"> Nome </label>
            <input type="text" class="form-control" name="nome" placeholder="Nome completo..."
              v-model="user.name" v-validate="{ required: true, min: 4, regex: /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/ }"
              :class="{invalid: errors.has('nome')}">
            <span class="error">{{ errors.first('nome') }}</span>
          </div>

          <div class="form-group required">
            <label for="email" class="control-label" :class="{ invalid: errors.has('email')}"> Email </label>
            <input type="email" class="form-control" name="email" placeholder="email" disabled="true"
            v-model="user.email" v-validate="'required|email'" :class="{invalid: errors.has('email')}">
            <span class="error">{{ errors.first('email') }}</span>
          </div>

          <div v-show="false">
            <input class="form-control" id="file" type="file" name="photo"
            v-validate="{ required: false, size:100, mimes:[ 'image/jpeg', 'image/png' ] }" @change="previewImage($event)" >
          </div>

          <div class="image-prev text-center">
            <img :src="photo" alt="user image" :class="{invalid: errors.has('photo')}"
            onclick="document.getElementById('file').click()" >
          </div>

          <div class="error" v-if="errors.first('photo')">
            <p>A imagem deve ser menor que <strong>100KB</strong></p>
          </div>

        </div>

        <div class="col-sm-6">
          <h3 class="text-center">Senha e Confirmação</h3>

          <div class="form-group required">
            <label for="senha" class="control-label" :class="{ invalid: errors.has('senha')}"> Senha </label>
            <input :type="fieldType" class="form-control input-btn" name="senha" placeholder="*****"
            v-model="user.password" v-validate="'required|min:4'" :class="{invalid: errors.has('senha')}">
            <span class="error">{{ errors.first('senha') }}</span>
          </div>

          <div class="form-group">
            <label for="confirm" :class="{ invalid: errors.has('confirm')}"> Confirmação </label>
            <input :type="fieldType" class="form-control" name="confirm" placeholder="*****"
            v-model="user.pass_confirm" v-validate="{ confirmed: user.password, required: true }" :class="{invalid: errors.has('confirm')}">
            <span class="error" v-if="errors.first('confirm')">Senha e confirmação devem ser iguais</span>
          </div>

          <div class="form-check">
            <input class="form-check-input" type="checkbox" @click="passVisibility">
            <label class="form-check-label"> Exibir senha</label>
          </div>

          <div style="margin-top: 120px;">

            <button class="btn btn-w-m btn-danger "
              v-if="errors.first('photo') || user.photo"
              @click.prevent="removePhoto()">
              Remover Imagem
            </button>

            <button class="btn btn-w-m btn-success pull-right"
              :disabled="disable" @click.prevent="submit(user)">
              Enviar
            </button>
          </div>

        </div>

      </div>
    </div>

    <p class="m-t"> <small>SS PARISI todos direitos reservados &copy; {{ year }}</small> </p>

  </div>
</template>

<script>

  import Spinner from './layout/Spinner'
  import { httpService } from '../providers/http-service'
  import { mapGetters, mapActions } from 'vuex'
  import { toast } from '../mixins/toast'
  import { errorMessage } from '../mixins/error-message'
  import { jwtDecode } from 'jwt-decode'

  export default {
    mixins: [ toast, errorMessage ],
    components: { Spinner },
    data() {
      return {
        token: '',
        showSpinner: false,
        disable: false,
        fieldType: 'password',
        photo:'/static/img/profile.jpg',
        userExtracted: { },
        user: {
          name: '',
          email: '',
          password: '',
          pass_confirm: '',
          photo: ''
        },
        year: new Date().getFullYear()
      }
    },
    methods: {

      ...mapActions(['setLoggedUser', 'setPermissions']),

      submit(user) {
        this.disable = true
        this.$validator.validateAll().then((valid) => {
          if(valid) {
            this.showSpinner = true
            user.token = this.token
            httpService.completeRegistry(user)
              .then(() => {
                this.show_toast('success', 'Sucesso', 'Cadastro completo!')
                return httpService.login({ email: this.user.email, password: this.user.password })
              })
              .then(res => {
                let user = res.data
                localStorage.setItem('token', user.token)
                this.setLoggedUser({ id: user.public_key, name: user.name, email: user.email , img: user.image, token: user.token, companies: user.companies })
                this.setPermissions(user.companies)
                this.showSpinner = false
                this.$router.push('/home')
              })
              .catch(err => this.showErrorMessage({ err: err }))
          } else {
            this.disable = false
            this.showSpinner = false
            this.show_toast('warning', 'Atenção', 'Verifique novamente os campos informados!')
            this.$validator.validateAll()
          }
        })
      },

      removePhoto() {
        this.photo = '/static/img/profile.jpg'
        this.user.photo = ''
        this.errors.remove('photo')
      },

      previewImage(event) {
        let input = event.target
        if(input.files && input.files[0]) {
          var reader = new FileReader()
          reader.onload = (e) => {
            this.photo = e.target.result
            this.user.photo = e.target.result
          }
        }
        if(input.files[0]) { reader.readAsDataURL(input.files[0]) }
      },

      passVisibility() { this.fieldType = this.fieldType === 'password' ? 'text' : 'password' },
    },
    mounted() {
      this.token = this.$route.query.token
      this.user = jwtDecode(this.token)
    }
  }
</script>

<style scoped>

  .loginscreen.middle-box {
    width: 580px;
    margin-left: -250px;
    margin-top: -360px;
  }

  .image-logo { height: 200px; position: relative; }

  .image-logo img {
    display: block;
    max-width: 300px;
    position: absolute;
    bottom:0;
    left:50%;
    transform:translateX(-50%);
    margin: 10px;
  }

  .ibox-content {
    width: 600px;
    text-align: left;
  }

  .error p {
    margin-top: 4px;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/UserRegistryPage.vue